import { SearchInput } from "@/components/atoms";
import { useGetUninvoicedJobsCompaniesParams } from "../hooks";
import { usePagination } from "@/hooks";

export const UninvoicedJobsCompaniesSearch = () => {
  const { search, setSearch } = useGetUninvoicedJobsCompaniesParams();
  const { clearPagination } = usePagination("uninvoicedJobs");

  const handleSearch = (value?: string) => {
    clearPagination();
    setSearch(value);
  };

  return <SearchInput search={search} onSearch={handleSearch} placeholder="Search..." size="md" />;
};
